export default "__VITE_ASSET__8d9128f2__"